<template>
    <div class="app-layout" id="app-layout-master">
        <div class="app-layout__wrapper" v-if="store">
            <div class="app-layout__sidebar-wrapper">
                <side-bar v-model="groups" @onBreakpointed="breakpointed = $event.status" @onBreakpointSubMenu="breakpointSubMenu = $event.status">
                    <img slot="logo" src="@/assets/logo.svg" alt="Swift"/>
                    <template slot="logosm">
                        <router-link to="/">
                            <img style="height: 40px;" src="@/assets/logo-sm.svg" />
                        </router-link>
                    </template>
                    <!-- <div slot="footer-sm" class="all-center" style="padding: 1em;">
                        <img src="@/assets/images/icons/500.png" alt="SMS" width="40" />
                    </div> -->
                    <template slot="footer">
                        <!-- <div v-if="store.app_plan === 'actual' && store.trial_end && new Date() < new Date(store.trial_end)" class="trial-premium-feature">
                            <i class="fal fa-times"></i>
                            <h6 class="m-b-4">{{ $t('app.trial_premium_feature.in_premium_plan') }}</h6>
                            <span v-html="$t('app.trial_premium_feature.trial_end_in', {time: getEndDate()})">
                            </span>
                            <a-button class="m-t-10" v-if="new Date().getMonth() == new Date(store.trial_end).getMonth() && new Date(store.trial_end).getDate() - new Date().getDate() === 3" type="primary" @click="$router.push({name: $routerName.PRICING})">{{ $t('app.buttons.upgrade_plan') }}</a-button>
                        </div> -->
                        <div class="sidebar__available-words" v-if="store.plan_info && store.plan_info.optimize_images">
                            <div class="fz-14">
                                <label class="m-0 m-r-6">{{ $t('app.available_images.title') }}</label>
                                <a-tooltip overlayClassName="" :prefixCls="$prefixClass.tooltip" placement="right"
                                    :title="$t('app.available_images.description')">
                                    <i class="fal fa-question-circle fs-sm cursor-pointer"></i>
                                </a-tooltip>
                            </div>
                            <label class="m-0 fz-30 primary-color-dark-1">{{Number(store.buymore_images_available + store.default_images_available)}}</label><br>
                            <div class="m-t-8 primary-color fw-300 cursor-pointer" @click="onRefresh">
                                <i class="fal fa-sync m-r-8 sidebar-fa-sync"></i>
                                <span>{{$t('app.buttons.refresh')}}</span>
                            </div>
                            <a-button class="m-t-14" type="primary" @click="buyMoreImages">{{$t('app.buttons.buy_more_images')}}</a-button>
                        </div>
                    </template>
                    <template slot="footer-sm">
                        <div v-if="store.plan_info && store.plan_info.optimize_images" :class="['footer-sm__buy-images', footerSm.moreImages ? 'active' : '']">
                            <img :src="require('@/assets/images/'+(footerSm.moreImages ? 'more-images-active.svg' : 'more-images.svg'))" alt=""/>
                        </div>
                    </template>
                </side-bar>
            </div>
            <div :class="['app-layout__body', classPageWrapper ? `app-layout__body__${classPageWrapper}` : '']">
                <!-- <div class="app-layout__header">
                     <VueRatingBar v-if="accountSettings && store.is_show_rating_bar"
                        :modalTitle="$t('app.rating_bar.bad_feedback_title')"
                        :modalDesc="$t('app.rating_bar.bad_feedback_desc')"
                        :content="$t('app.rating_bar.title', {first_name: `<strong>${accountSettings.full_name}</strong>`})"
                        :options="reasonOptions"
                        class="m-b-24"
                        style="width: 100%;"
                        ref="ratingBar"
                        :placeholderOther="$t('app.rating_bar.other_placeholder')"
                        @click-good-btn="onClickGoodBtnRatingBar"
                        @submit-bad-feedback="submitBadFeedback"
                        @click-cross-mark-btn="onHideRatingBar"
                    />
                    <vue-modal v-model="rateSuccessedVisible" :header="false" :footer="false" :backdrop="false"
                        :closable="false" :modalBodyClass="$prefixClass.modal + '-rate-successed'" class="text-center">
                        <i class="far fa-times" @click="rateSuccessedVisible = false"></i><br>
                        <i class="fad fa-check-circle m-b-13"></i><br>
                        <h4 class="m-b-12">{{$t('app.rating_bar.thanks_feedback')}}</h4>
                        <p class="m-b-14">
                            {{$t('app.rating_bar.thanks_feedback_description')}}
                        </p>
                        <div>
                            <a-button type="secondary" class="m-r-9" @click="rateSuccessedVisible = false">{{$t('app.buttons.maybe_later')}}</a-button>
                            <a-button type="primary" @click="contactUs">{{$t('app.buttons.contact_us')}}</a-button>
                        </div>
                    </vue-modal>
                    <m-header
                        :accountRoute="{name: this.$routerName.ACCOUNT_SETTINGS}"
                        :store="store"
                        :accountSettings="accountSettings"
                        @logout="logoutAccount"
                        hideRateUs
                        hideBreadcrumbRoot>
                        <a-button slot="prefix-profile" type="primary" ghost class="fz-16" @click="onRateUs"><i class="fa fa-star  m-r-5"></i> {{$t('app.buttons.rate_us')}}</a-button>
                    </m-header>
                    <vue-modal-rate-us v-model="rateUsVisible" href="https://apps.shopify.com/swift-3#modal-show=ReviewListingModal"></vue-modal-rate-us>
                </div> -->
                <div :class="['app-layout__container', classPageWrapper ? `app-layout__container__${classPageWrapper}` : '']">
                    <div class="app-layout__content wrapper-space">
                        <template>
                            <transition name="fade-in" mode="out-in">
                                <router-view />
                            </transition>
                        </template>
                    </div>
                    <!-- <div class="app-layout__footer">
                        <m-footer companyName="PerfectApps"
                            linkCompany="https://perfectapps.io"
                            linkTermOfUse="https://help.perfectapps.io/en/article/terms-of-service-1ia1se9/?1600759237221"
                            linkPrivacyPolicy="https://help.perfectapps.io/en/article/privacy-policy-2xwygu/?1600759237219"
                            linkPaymentPolicy="https://help.perfectapps.io/en/article/cookie-policy-1g0fdgg/?1600759237215"
                            linkText3="Cookie Policy"
                        />
                    </div> -->
                </div>
                <vue-notification-bar v-if="store && store.plan_info && store.plan_info.optimize_images"
                    v-model="imagesLimitBar"
                    @doAction="buyMoreImages"
                    @onCancel="onCancelBar"
                >
                </vue-notification-bar>
                <vue-modal-subscribe-image v-model="subscribeImageVisible" @buy-more-images="buyMoreImageVisible = true"></vue-modal-subscribe-image>
                <vue-modal-buy-more-images v-if="imagePlans"
                    v-model="buyMoreImageVisible">
                </vue-modal-buy-more-images>
            </div>
        </div>
        <div class="banner-promotions">
            <div v-if="storeOnecommercesBannerVisible && !modalPromotionCode.visible && !modalPromotionCode.freeUsedVisible"
                class="banner-promotions__promo-code"
                @click="modalPromotionCode.visible = true">
            </div>
        </div>
        <modal-promotion-code v-model="modalPromotionCode"></modal-promotion-code>
        <modal-image-limit v-model="modalImageLimitVisible"
             @buy-more-images="buyMoreImages"
        ></modal-image-limit>
        <modal-notification v-model="modalNotification"
            @set-up-optimization="setUpOptimization"
            @optimize-later="optimizeLater"
        >
        </modal-notification>
        <vue-modal-sucess v-model="modalPurchaseSuccess" :closable="true"></vue-modal-sucess>
        <vue-optimize-progress
            v-model="optimazing"
            @reload-data="reloadData"
        >
        </vue-optimize-progress>
        <vue-modal-trial-ended v-model="modalTrialEndedVisible"></vue-modal-trial-ended>
        <vue-modal-plan-notification v-model="modalPlanNotificate"></vue-modal-plan-notification>
        <!-- <vue-modal-affiliate v-model="modalAffiliate"></vue-modal-affiliate> -->
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations  } from 'vuex'
    import { types as typesAuth } from '@/modules/auth/constant'
    import { types as typesAccountSettings } from '@/modules/account_settings/constant'
    import { types as typesOptimize } from '@/modules/optimize_image/constant'
    import { types as typesPromotions } from "@/modules/promotion/constant"
    import ModalImageLimit from '@/modules/optimize_image/components/ModalImageLimit'
    import ModalNotification from '@/modules/optimize_image/components/ModalNotification'
    import { types as typesCharge } from '@/modules/charge/constant'
    import routerName from '@/constants/routers'
    import i18n from '@/i18n'
    import cookie from 'js-cookie'
    import isEmpty from "lodash/isEmpty"
    import findIndex from "lodash/findIndex"
    import { store } from '@/main.js'
    import { PricingFeatureList } from '../modules/charge/views/PricingPlan'
    import SideBar from './SideBar.vue'
    import VueModalRateUs from '../components/VueModalRateUs.vue'
    import ModalPromotionCode from "@/modules/promotion/components/PromotionCode"

    export default {
        name: "DefaultLayout",
        components: {
            ModalNotification,
            SideBar,
            VueModalRateUs,
            ModalImageLimit,
            ModalPromotionCode
        },
        data() {
            return {
                buyImageSucessExclude: ['OptimizeImage', 'Dashboard'],
                buyMoreImageVisible: false,
                modalTrialEndedVisible: false,
                breakpointSubMenu: false,
                breakpointed: false,
                rateUsVisible: false,
                query: null,
                subscribeImageVisible: false,
                modalImageLimitVisible: false,
                rateSuccessedVisible: false,
                badFeedBack: [],
                storeOnecommercesBannerVisible: false,
                modalPromotionCode: {
                    visible: false,
                    freeUsedVisible: false,
                    chargeSuccess: false
                },
                footerSm: {
                    moreImages: false
                },
                // modalAffiliate: {
                //     visible: false
                // },
                modalPlanNotificate: {
                    isVisible: false,
                    type: ''
                },
                modalQuickTutorial: {
                    isVisible: false,
                    type: 'preloading'
                },
                modalNotification : {
                    isVisible: false,
                    type: 'primary'
                },
                modalPurchaseSuccess: {
                    isVisible: false,
                    title: this.$t('app.modal.purchase_sucessfully')
                },
                imagesLimitBar: {
                    visible: false,
                    btnSave: 'Buy more images',
                    type: 'images-limit'
                },
                optimazing: {
                    isVisible: false,
                    image: null,
                    theme: null
                },
                reasonOptions: [
                    {
                        value: 1,
                        label: this.$t('app.rating_bar.reason_1')
                    },
                    {
                        value: 2,
                        label: this.$t('app.rating_bar.reason_2')
                    },
                    {
                        value: 3,
                        label: this.$t('app.rating_bar.reason_3')
                    },
                    {
                        value: 4,
                        label: this.$t('app.rating_bar.reason_4')
                    }
                ],
                groups:  [
                    {
                        title: i18n.t('app.menu.dashboard'),
                        route: routerName.DASHBOARD,
                        key: routerName.DASHBOARD,
                        type: 'router-link',
                        icon: '<i class="far fa-home"></i>',
                        tooltip: false,
                        index: 0
                    },
                    {
                        title: i18n.t('app.menu.swift_expert'),
                        route: routerName.SWIFT_EXPERT,
                        key: routerName.SWIFT_EXPERT,
                        type: 'router-link',
                        icon: '<i class="far fa-rabbit-fast"></i>',
                        tooltip: false,
                        index: 1,
                        status: 'new'
                    },
                    /* {
                        title: i18n.t('app.menu.actual_speed'),
                        route: routerName.OPTIMIZE_IMAGE,
                        key: routerName.OPTIMIZE_IMAGE,
                        type: 'router-link',
                        icon: '<i class="far fa-tachometer-alt-slowest"></i>',
                        tooltip: false,
                        index: 2
                    }, */
                    /* {
                        title : i18n.t('app.menu.perceived_speed'),
                        route : '',
                        key: 'PerceivedSpeed',
                        type : 'sub-menu',
                        icon : '<i class="far fa-head-side-brain"></i>',
                        tooltip: false,
                        index: 3,
                        sub: [
                            {
                                title : i18n.t('app.menu.preloading'),
                                route : routerName.PRELOADING,
                                key: routerName.PRELOADING,
                                type : 'router-link',
                                icon : '',
                                tooltip: false
                            },
                            {
                                title: i18n.t('app.menu.loading_screen'),
                                route: routerName.LOADING_SCREEN,
                                key: routerName.LOADING_SCREEN,
                                type: 'router-link',
                                icon: '',
                                tooltip: false
                            }
                        ]
                    }, */
                    {
                        title: i18n.t('app.menu.pricing'),
                        route: routerName.PRICING,
                        key: routerName.PRICING,
                        type: 'router-link',
                        icon: '<i class="far fa-tag"></i>',
                        index: 3
                    },
                    {
                        title : i18n.t('app.menu.boost_sales'),
                        route : '',
                        key: 'Boost Sales',
                        type : 'sub-menu',
                        icon : '<i class="far fa-shopping-cart"></i>',
                        tooltip: false,
                        index: 5,
                        sub: [
                            {
                                title : this.$t('app.menu.ali_reviews'),
                                route : '',
                                key: 'Ali Reviews',
                                onClick: ()=>{
                                    window.open('https://apps.shopify.com/ali-reviews?utm_source=fa-cross-app&utm_medium=boost-sales-menu', '_blank')
                                },
                                type : 'button',
                            },
                            {
                                title : this.$t('app.menu.transcy'),
                                route : '',
                                key: 'Transcy',
                                onClick: ()=>{
                                    window.open('https://apps.shopify.com/transcy-multiple-languages?utm_source=fa-cross-app&utm_medium=boost-sales-menu', '_blank')
                                },
                                type : 'button',
                            },
                            {
                                title : this.$t('app.menu.messent'),
                                route : '',
                                key: 'Messent',
                                onClick: ()=>{
                                    window.open('https://apps.shopify.com/sms-messent?utm_source=fa-cross-app&utm_medium=boost-sales-menu', '_blank')
                                },
                                type : 'button',
                            },
                            {
                                title : this.$t('app.menu.chatalyst'),
                                route : '',
                                key: 'Chatalyst',
                                onClick: ()=>{
                                    window.open('https://apps.shopify.com/chatalyst?utm_source=fa-cross-app&utm_medium=boost-sales-menu', '_blank')
                                },
                                type : 'button',
                            },
                            {
                                title : this.$t('app.menu.sales_box'),
                                route : '',
                                key: 'Sales Box',
                                onClick: ()=>{
                                    window.open('https://apps.shopify.com/shipping-information-by-fireapps?utm_source=fa-cross-app&utm_medium=boost-sales-menu', '_blank')
                                },
                                type : 'button',
                            }
                        ]
                    }
                ]
            }
        },
        computed: {
            ...mapGetters({
                store: typesAuth.getters.GET_STORE,
                accountSettings: typesAccountSettings.getters.GET_ACCOUNT_SETTINGS,
                optimizeProcess: typesOptimize.getters.GET_OPTIMIZE_PROCESS,
                imagePlans: typesCharge.getters.GET_IMAGE_PLANS,
                newOptimize: typesOptimize.getters.GET_NEW_OPTIMIZE,
                autoSettings: typesOptimize.getters.GET_AUTO_SETTINGS,
                trial: typesCharge.getters.GET_TRIAL,
                isShowMenuTooltip : 'getShowMenuTooltip',
            }),
            classPageWrapper() {
                return this.$route.name && this.$route.name.toLowerCase() || ''
            }
        },
        created() {
            this.query =  this.$clone(this.$route.query)
            this.featchData()
        },
        metaInfo: {
            titleTemplate: function (t) {
                return `${t} - ${this.$app.name}`
            }
        },
        watch: {
            $route(to, from) {
                if(to.name === from.name) return;
                // this.checkShowPopupAffiliate()
            },
            store: {
                handler() {
                    this.showImagesLimitBar()
                },
                deep: true
            },
            optimizeProcess: {
                handler( process ) {
                    this.runProcess(process)
                },
                deep: true
            },
            newOptimize: {
                handler(data) {
                    this.featchNewOptimize()
                },
                deep: true
            },
            autoSettings: {
                handler() {
                    this.featchNewOptimize()
                },
                deep: true
            },
            isShowMenuTooltip: {
                handler(val) {
                    this.showTooltip()
                },
                deep: true
            },
            breakpointSubMenu: {
                handler(val) {
                    this.setBreakpointSubMenu(val)
                    this.footerSm.moreImages = this.breakpointSubMenu
                },
                deep: true
            }
        },
        methods: {
            ...mapActions({
                // initOneSignal: 'initOneSignal',
                getImagePlans: typesCharge.actions.GET_IMAGE_PLANS,
                initIntercom: typesAuth.actions.INIT_INTERCOM,
                initCripsChat: typesAuth.actions.INIT_CRISP_CHAT,
                toggleShowIntercom: typesAuth.actions.TOGGLE_SHOW_INTERCOM,
                logout: typesAuth.actions.LOGOUT,
                getAccountSettings: typesAccountSettings.actions.GET_ACCOUNT_SETTINGS,
                getStore: typesAuth.actions.GET_STORE,
                checkNewOptimize: typesOptimize.actions.CHECK_NEW_OPTIMIZE,
                destroyIntercom : typesAuth.actions.DESTROY_INTERCOM,
                getProcess: typesOptimize.actions.GET_PROCESS,
                getLogs: typesOptimize.actions.GET_ALL_LOGS,
                getActualOverview: typesOptimize.actions.GET_OVER_VIEW,
                getAutoSettings: typesOptimize.actions.GET_AUTO_SETTINGS,
                hideRatingBar: typesAuth.actions.HIDE_RATING_BAR,
                getBannerOnecommerces: typesPromotions.actions.GET_BANNER_ONECOMMERCES
            }),
            ...mapMutations({
                setBreakpointSubMenu: 'setBreakpointSubMenu'
            }),
            async featchData() {
                clearInterval(this.timer)
                // this.initOneSignal()
                this.initIntercom()
                this.getAccountSettings()
                this.showModalBuyImageSucess()
                if ( !this.newOptimize ) {
                    this.checkNewOptimize()
                }
                if ( !this.optimizeProcess ) {
                    this.getProcess()
                } else {
                    this.runProcess()
                }
                if ( !this.imagePlans ) {
                    this.getImagePlans()
                }
                if ( !this.autoSettings ) {
                    await this.getAutoSettings()
                }
                if ( !this.store ){
                    await this.getStore().then(() => {
                        this.initCripsChat()
                    });
                } else {
                    this.initCripsChat()
                }
                this.checkShowBannerOnecommerces()
                this.showImagesLimitBar()
                this.showTooltip()
                this.showPlanNotification()
                // this.checkShowPopupAffiliate()
                this.openModalUpgrade()
            },
            // checkShowPopupAffiliate() {
            //     const cookieName = `hide_modal_affiliate_${this.store.id}`
            //     if ( !cookie.get(cookieName) || cookie.get(cookieName) !== 'true') {
            //         this.modalAffiliate.visible = true
            //     }
            // },
            showModalBuyImageSucess() {
                let isBuyMoreImage = !isEmpty(this.query) && this.query.hasOwnProperty('image_plan_name')
                if ( !this.buyImageSucessExclude.includes(this.$router.currentRoute.name) && isBuyMoreImage) {
                    this.modalPurchaseSuccess.isVisible = true
                    this.modalPurchaseSuccess.description = this.$t('app.modal.purchase_sucess_description', {num: this.query.image_plan_name})
                    this.setQuery({})
                }
            },
            async checkShowBannerOnecommerces() {
                let self = this
                await this.getBannerOnecommerces().then(res => {
                    let { status = false} = res.data;
                    if (status) {
                        self.storeOnecommercesBannerVisible = true
                    }
                })
                .catch(e => {
                    console.log(e);
                });
            },
            openModalUpgrade() {
                let query = this.$clone(this.$route.query)
                let isUpgradePlan = !isEmpty(query) 
                                    && query.hasOwnProperty('plan')
                                    && query.plan !== ''
                if (isUpgradePlan) {
                    let onecommercePromo = query.hasOwnProperty('onecommerce_promo') && query.onecommerce_promo === 'true'
                    if (onecommercePromo) {
                        this.modalPromotionCode.chargeSuccess = true
                    }
                }
                delete query.plan
                delete query.end_trial
                delete query.onecommerce_promo
                this.setQuery(query)
            },
            setQuery(query) {
                this.pushRouterLinkDefault({
                    name: this.$routerName[this.$router.currentRoute.name],
                    query: query,
                });
            },
            featchNewOptimize() {
                if ( this.newOptimize && this.autoSettings && this.store.app_plan !== 'perceived' ) {
                    let data = this.$clone(this.newOptimize)
                     if ( this.$router.currentRoute.name != this.$routerName.OPTIMIZE_IMAGE ) {
                        let optType = ( data.image.total > this.maximumImagePopup && data.theme.total > this.maximumThemePopup && !this.autoSettings.optimize_image && !this.autoSettings.optimize_theme) ? 'all' : ( data.image.total > this.maximumImagePopup && !this.autoSettings.optimize_image ? 'image' : ( data.theme.total > this.maximumThemePopup && !this.autoSettings.optimize_theme ? 'theme' : ''))
                        if ( optType ) {
                            if ( !cookie.get('show-modal-result') ) {
                                let modal = {
                                    type: 'needed',
                                    optType: optType,
                                    detail: {
                                        images: data.image.total,
                                        saved: data.image.total_saved,
                                        files: data.theme.total
                                    }
                                }
                                this.showModalResult(modal)
                            }
                        }
                    }
                    if ( data.new_theme_publish && !cookie.get('show-modal-new-theme') ) {
                        this.showModalNewTheme()
                    }
                }
            },
            logoutAccount() {
                this.destroyIntercom()
                this.logout()
            },
            runProcess(process) {
                this.optimazing.isVisible = false
                this.optimazing.image = null
                this.optimazing.theme = null
                process = process ? process : this.optimizeProcess
                if ( process.image ) {
                    let percentPerImage = 100/ process.image.total
                    this.optimazing.image = {
                        total:  process.image.total,
                        count:  process.image.total_compressed ?  process.image.total_compressed : 0,
                        percent:  process.image.total_compressed ?  process.image.total_compressed*percentPerImage : 0,
                        percentPerImage: percentPerImage
                    }
                }
                if ( process.theme ) {
                    this.optimazing.theme = {
                        percent: process.theme.percent,
                        settings: cookie.get('actual_optimize_settings') ? JSON.parse(cookie.get('actual_optimize_settings')).settings : []
                    }
                }
                if ( this.optimazing.image || this.optimazing.theme ) {
                    this.optimazing.isVisible = true
                    store.commit('setOptimizing', true)
                } else {
                    store.commit('setOptimizing', false)
                }
            },
            onRateUs() {
                this.rateUsVisible = true
                // window.open('https://apps.shopify.com/swift-3#modal-show=ReviewListingModal', '_blank')
            },
            async onRefresh() {
                let self = this
                let refreshIcon = document.querySelector('.sidebar-fa-sync')
                $(refreshIcon).addClass('fa-pulse')
                await this.getStore().then(res => {
                    let { status = false, data = [], message} = res.data;
                    if (status) {
                        self.toastSuccess({
                            title: this.$t('app.available_images.update_success'),
                            duration: 2
                        });
                    } else {
                        self.toastError({
                            title: "Error",
                            message: self.$t('app.errors.something_went_wrong'),
                            duration: 4
                        })
                    }
                    setTimeout(() => {
                        $(refreshIcon).removeClass('fa-pulse')
                    }, 800)
                })
                .catch(e => {
                    $(refreshIcon).removeClass('fa-pulse')
                    console.log(e);
                });
            },
            showModalNewTheme() {
                this.modalNotification.title = this.$t('optimize_image.notification_bar.theme.title')
                this.modalNotification.description = this.$t('optimize_image.notification_bar.theme.new_theme_description')
                this.modalNotification.cancelText = this.$t('optimize_image.buttons.later')
                this.modalNotification.btnText = this.$t('optimize_image.buttons.set_up_optimization')
                this.modalNotification.cancelAction = 'optimize-later'
                this.modalNotification.action = 'set-up-optimization'
                this.modalNotification.isVisible = true
            },
            setUpOptimization() {
                this.optimizeLater()
                store.commit('setAutoOpenOptimizeMethod', true)
                this.$router.push({
                    name: this.$routerName.OPTIMIZE_IMAGE
                })
            },
            optimizeLater() {
                cookie.set('show-modal-new-theme', true, { expires: 30 } )
            },
            onCancelBar() {
                cookie.set('show-bar-image-limit', true, { expires: 30 } )
                this.imagesLimitBar.visible = false
            },
            reloadData({limitCompressImages=false}) {
                this.getStore()
                if ( this.$router.currentRoute.name == this.$routerName.OPTIMIZE_IMAGE ) {
                    this.modalImageLimitVisible = limitCompressImages
                    store.commit('setOptimizeSuccess', true)
                } else {
                    this.getActualOverview()
                    this.checkNewOptimize()
                }
            },
            buyMoreImages() {
                if (this.store && this.store.trial_end && new Date(this.store.trial_end) > new Date()) {
                    this.subscribeImageVisible = true
                } else {
                    this.buyMoreImageVisible = true
                }
            },
            // getEndDate() {
            //     return moment().to(moment(this.store.trial_end)).replace('in', '')
            // },
            showTime() {
                if ( isEmpty(this.query) && this.store.app_plan === 'actual' && !cookie.get('close-modal-trial-ended')) {
                    let sameMonth = new Date().getMonth() == new Date(this.store.trial_end).getMonth()
                    if (this.store.trial_end && sameMonth && new Date(this.store.trial_end).getDate() - new Date().getDate() <= 0 ) {
                        if ( new Date() >= new Date(this.store.trial_end) ) {
                            this.modalTrialEndedVisible = true
                        } else {
                            this.timer = setInterval(() => {
                                if ( new Date() >= new Date(this.store.trial_end)) {
                                    clearInterval(this.timer)
                                    this.modalTrialEndedVisible = true
                                }
                            }, 30*1000)
                        }
                    }
                }
            },
            showTooltip () {
                if (cookie.get('show-tooltip') != undefined) {
                    let showTooltip = JSON.parse(cookie.get('show-tooltip'))
                    let perceivedIndex = findIndex(this.groups, (o) => {
                        return o.key == 'PerceivedSpeed'
                    })
                    if (showTooltip.perceived != undefined) {
                        if (!showTooltip.perceived.isShowedTTPerceived && showTooltip.perceived.showTTPerceived) {
                            this.groups[perceivedIndex].tooltip = true
                            return
                        } else if (showTooltip.perceived.showTTLoading != undefined && !showTooltip.perceived.isShowedTTLoading && showTooltip.perceived.showTTLoading) {
                            let loadingIndex = findIndex(this.groups[perceivedIndex].sub, (o) => {
                                return o.key == this.$routerName.LOADING_SCREEN
                            })
                            this.groups[perceivedIndex].sub[loadingIndex].tooltip = true
                            return
                        } else if (showTooltip.perceived.showTTPreloading != undefined && !showTooltip.perceived.isShowedTTPreloading &&  showTooltip.perceived.showTTPreloading) {
                            let preloadingIndex = findIndex(this.groups[perceivedIndex].sub, (o) => {
                                return o.key == this.$routerName.PRELOADING
                            })
                            this.groups[perceivedIndex].sub[preloadingIndex].tooltip = true
                            return
                        }
                    }
                    if (showTooltip.actual != undefined) {
                        // Show tooltip actual
                        if (showTooltip.actual.showTTActual != undefined && !showTooltip.actual.isShowedTTActual && showTooltip.actual.showTTActual) {
                            let actualIndex = findIndex(this.groups, (o) => {
                                return o.key == this.$routerName.OPTIMIZE_IMAGE
                            })
                            this.groups[actualIndex].tooltip = true
                            return
                        }
                    }
                    return;
                }
            },
            submitBadFeedback(value) {
                this.badFeedBack = []
                let reasons = []
                value.forEach(element => {
                    reasons.push(element.label)
                    this.badFeedBack.push(Number(element.value) ? element.label : element.label+': '+element.text)
                });
                //CONFIRM
                $crisp.push(["set", "session:segments", [reasons, true]])
                // $linebase.set("message", "tag", [reasons])
                this.rateSuccessedVisible = true
                this.$refs.ratingBar.isShowBadModal = false
                this.onHideRatingBar()
            },
            onClickGoodBtnRatingBar() {
                window.open('https://apps.shopify.com/swift#modal-show=ReviewListingModal', '_blank')
            },
            contactUs() {
                //CONFIRM
                $crisp.push(["do", "message:send", ["text", this.$t('app.rating_bar.reason_title')]])
                // $linebase.do("message", "send", ["text", this.$t('app.rating_bar.reason_title')])
                this.badFeedBack.forEach(reason => {
                    $crisp.push(["do", "message:send", ["text", reason]])
                    // $linebase.do("message", "send", ["text", reason])
                });
                this.openBoxChat()
                this.rateSuccessedVisible = false
            },
            async onHideRatingBar() {
                await this.hideRatingBar()
                this.getStore()
            },
            showPlanNotification() {
                this.modalPlanNotificate.isVisible = Number(this.store.pricing_version) === 1 && !cookie.get('hide-modal-plan-notification')
                this.modalPlanNotificate.type = this.modalPlanNotificate.isVisible ? this.store.app_plan : ''
            },
            showImagesLimitBar() {
                this.imagesLimitBar.visible = Number(this.store.buymore_images_available + this.store.default_images_available) === 0 && !cookie.get('show-bar-image-limit')
                this.showTime()
            }
        }
    };
</script>
<style lang="scss">
    .app-layout__header{
        &:after{
            content: none !important;
        }
    }
    .banner-promotions {
        z-index: 9999;
        position: fixed;
        top: calc(50% - 82px);
        right: 0;
        &__promo-code {
            cursor: pointer;
            color: #fff;
            box-shadow: -4px 20px 32px -12px rgba(0, 0, 0, 0.15);
            width: 37px;
            height: 173px;
            background-image: url('../modules/promotion/assets/icons/promotion-thumnail.png');
        }
    }
    .#{$modal}-rate-successed {
        .#{$modal} {
            &-content {
                border-radius: 8px;
            }
            &-body {
                padding: 12px 85px 32px 85px;
                .fa-times {
                    float: right;
                    font-size: 20px;
                    color: #d4d4d4;
                    margin-right: -69px;
                    &:hover {
                        cursor: pointer;
                    }
                }
                .fa-check-circle {
                    font-size: 48px;
                    color: $success-color;
                    opacity: 0.6;
                }
            }
        }
    }
    .preview-area {
        border: 1px dashed #CCC;
        border-radius: 10px;
        padding: 1em;
        background: #f6f6f6;

        &.f-col {
            display: flex;
            flex-direction: column;

            >* {
                margin-bottom: 1em;
            }
        }
    }

    pre {
        line-height: 1.4;
        padding: 1.25rem 1.5rem;
        margin: 0.85rem 0;
        background-color: #282c34;
        border-radius: 6px;
        overflow: auto;

        code {
            font-size: 1.25em;
            color: #fff;
            padding: 0;
            background-color: transparent;
            border-radius: 0;
        }
    }

    .m-sidebar-footer {
         &-sm {
            margin: 8px;
            .footer-sm {
                &__buy-images {
                    height: 72px;
                    display: flex;
                    justify-content: center;
                    border-radius: 8px;
                    padding: 8px;
                    background: $primary-light;
                    &.active {
                        background: $primary-color;
                    }
                }
            }
        }
        .sidebar {
            &__available-words {
                margin: 0 8px 8px 8px;
                border-radius: 8px;
                background: $primary-light;
                padding: 16px;
                > button {
                    width: 100%;
                }
            }
        }
        // .trial-premium-feature {
        //     background: #cfe8ff;
        //     padding: 24px;
        //     .fa-times {
        //         float: right;
        //         font-size: 14px;
        //         margin-top: -8px;
        //         margin-right: -5px;
        //         color: $text-color-3;
        //         &:hover {
        //             cursor: pointer;
        //         }
        //     }
        // }
    }
</style>
